// extracted by mini-css-extract-plugin
module.exports = {"label":"KTextField_label__b7A3y","multilineInput":"KTextField_multilineInput__7JU1Z"};